import Link from 'client/components/aria/Link/Link';
import LinkedFile from './LinkedFile';
import Icon from '@mdi/react';
import { mdiOpenInNew } from '@mdi/js';
import styles from './InfoBox.module.scss';
import {
    getAssetFromLinkedFilesAndGuidances,
    sortGuidancesByDescriptionLength
} from 'client/utils/helpers/LinkedFiles/LinkedFilesUtils';
import {
    ABSOLUTE_URL_REGEX,
    prettifyUrl,
    isLikelyUrl,
    addProtocolToUrl
} from 'client/utils/helpers/UrlUtils/UrlsUtils';

export const renderDescriptionWithLinks = (description, defaultDescription, name) => {
    const content = description || defaultDescription;

    if (typeof content !== 'string' || !content.trim()) {
        return content;
    }

    const parts = content.split(ABSOLUTE_URL_REGEX);

    return parts.map((part, index) => {
        if (!isLikelyUrl(part)) {
            return <span key={`${part}-${index}`}>{part}</span>;
        }

        return <Link
            className={['govuk-link', styles.guidanceLink].join(' ')}
            href={addProtocolToUrl(part)}
            key={`${part}-${index}`}
            target='_blank'
            rel='noreferrer'
        >
            {prettifyUrl(part, name)}
            <Icon path={mdiOpenInNew} size={0.7} />
        </Link>;
    });
};

const LinkedFileAndGuidance = ({ linkedFilesAndGuidances, defaultDescription, contactButton, showContactButton = false }) => {
    const [{ assets, guidances, linkedFiles }] = linkedFilesAndGuidances;

    const assetInfo = getAssetFromLinkedFilesAndGuidances(assets, guidances, linkedFiles);
    const sortedGuidances = sortGuidancesByDescriptionLength(guidances);

    return (
        <>
            {sortedGuidances.map(guidance => {
                const { description, name, additionalInformation, linkedFiles } = guidance;
                return <div key={guidance?.systemid} className={styles.guidanceContainer}>
                    <span className='govuk-body-s govuk-!-margin-bottom-2'>
                        {renderDescriptionWithLinks(description, defaultDescription, name)}
                    </span>
                    {additionalInformation &&
                        <span className='govuk-body-s govuk-!-margin-bottom-2'>
                            {/* don't need to default because we have additional info */}
                            {/* render links in additional info as raw link */}
                            {renderDescriptionWithLinks(additionalInformation, '', '')}
                        </span>
                    }
                    {linkedFiles?.map(linkedFile => <LinkedFile key={linkedFile?.systemId} linkedFile={linkedFile} assetInfo={assetInfo} />)}
                </div>;
            })}

            {
                linkedFiles?.map(linkedFile => <LinkedFile key={linkedFile?.systemId} linkedFile={linkedFile} assetInfo={assetInfo} />
                )
            }

            {showContactButton ? contactButton() : null}
        </>
    );
};

export default LinkedFileAndGuidance;
